import { ValidationError } from "sequelize"
import {
    MarkovDataset,
    MarkovDatasetCreate,
    MarkovDatasetSave,
} from "server/models"
import { ASC } from "const"
import { GET, POST, DELETE, sort, validate } from "client/store/utils"
import { LangType } from "client/store"
import { MarkovDatasetValidation } from "./types"


export const LoadAllMarkovDatasets = (modelId: number) => (
    GET(`/markovDataset/modelId/${modelId}`)
    .then((datasets: MarkovDataset[]) => (
        datasets.sort((a, b) => sort(a, b, "order", ASC))
    ))
)

export const LoadMarkovDatasetById = (datasetId: number, modelId: number) => (
    GET(`/markovDataset/id/${datasetId}/modelId/${modelId}`)
    .then((dataset: MarkovDataset) => dataset)
)

export const SaveMarkovDataset = (
    id: number,
    dataset: MarkovDatasetCreate,
    lang: LangType,
) => {
    const data: MarkovDatasetSave = {
        id,
        dataset,
    }
    return POST(
        "/markovDataset/save",
        JSON.stringify(data),
    ).then((res) => {
        const newDataset = res as MarkovDataset
        const error = res as ValidationError

        return {
            newDatasetId: newDataset.id || null,
            validation: <MarkovDatasetValidation>validate(error, lang),
        }
    })
}

export const DeleteMarkovDataset = (datasetId: number, modelId: number) => (
    DELETE(`/markovDataset/delete/${datasetId}/${modelId}`)
    .then((removedRows: number) => removedRows)
)
